import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const KEY = "itz_welcomed";

export function WelcomeBack() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!user || user.vip_celebrate || sessionStorage.getItem(KEY) === user.user_id) return;
    const a = setTimeout(() => { sessionStorage.setItem(KEY, user.user_id); setShow(true); }, 400);
    const b = setTimeout(() => setShow(false), 4200);
    return () => { clearTimeout(a); clearTimeout(b); };
  }, [user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!show) return null;
  const first = (user.name || "").trim().split(/\s+/)[0] || "du";
  return (
    <div className="fixed top-3 inset-x-0 z-[95] flex justify-center px-4 pointer-events-none" data-testid="welcome-back">
      <button type="button" onClick={() => setShow(false)} className="pointer-events-auto welcome-drop flex items-center gap-3 pl-2 pr-5 py-2 rounded-full bg-white/95 backdrop-blur shadow-xl shadow-rose-200/70 ring-1 ring-rose-100">
        <span className="w-10 h-10 rounded-full pink-gradient flex items-center justify-center text-xl welcome-wave">👋</span>
        <span className="text-left">
          <span className="block text-[11px] font-bold uppercase tracking-widest text-rose-400">Herzlich willkommen zurück</span>
          <span className="block font-display text-lg font-extrabold text-slate-800 leading-tight" data-testid="welcome-back-name">{first} 💖</span>
        </span>
      </button>
    </div>
  );
}
